import Cookies from 'js-cookie';

export default defineNuxtRouteMiddleware(async (ctx) => {
  const cookieSessionId = Cookies.get('naat');
  
  if (!cookieSessionId) {
    return navigateTo('/sign-in');
  }
})
